import { Component, EventEmitter, Input, OnInit, Output, NgModule, Inject, AfterViewInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { ApiService } from '@services/api.service';
import { LocalizationService } from '@services/localization.service';

import { UiHelper } from '@helpers/ui.helper';
import { UserHelper } from '@helpers/user.helper';
import { TranslatePipe } from '@pipes/translate.pipe';
import { Router } from '@angular/router';

@Component({
  selector: 'casino-component',
  templateUrl: '../sharedTemplates/casino.component.html',
})
export class CasinoComponent implements OnInit, AfterViewInit {
  casinoList = [];
  gameTypes = [];

  selectedCasinoType = 0;

  constructor(
    private _ApiService: ApiService,
    private _UiHelper: UiHelper,
    private _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router
  ) {}

  ngOnInit() {
    this.gameTypes = [
      { id: 0, name: 'CasinoPopular', text: 'Popular' },
      { id: 1, name: 'CasinoSlot', text: 'Slot' },
      { id: 2, name: 'CasinoJackpot', text: 'Jackpot' },
      { id: 3, name: 'CasinoTable', text: 'Table' },
      { id: 4, name: 'CasinoCard', text: 'Card' },
      { id: 5, name: 'CasinoVideoPoker', text: 'Video Poker' },
    ];
  }

  ngAfterViewInit() {
    /*this._ApiService.getTranscationsTypes().then((x) => {
      this.transactionTypes = x;
      this.getBookings();
    });

    this._UiHelper.setRightMenu();*/

    this.getCasinoGames();
  }

  getCasinoGames() {
    this._ApiService.getCasinoGames(this.selectedCasinoType).then(x => {
      this.casinoList[this.selectedCasinoType] = x;

      if (this._UiHelper.leftMenu) this._UiHelper.setLeftMenu();
    });
  }

  casinoTypeChanged(e) {
    this.selectedCasinoType = e;
    this.getCasinoGames();
  }
}

@Component({
  selector: 'casino-item',
  templateUrl: '../sharedTemplates/casino.item.component.html',
})
export class CasinoItem {
  @Input() casinoList = [];
  @Input() item = [];

  constructor(
    private _UiHelper: UiHelper,
    private _UserHelper: UserHelper,
    private _LocalizationService: LocalizationService,
    private _router: Router,
    @Inject(DOCUMENT) private document: any
  ) {}

  openGame(e) {
    if (!this._UserHelper.isSignedIn) {
      const translator = new TranslatePipe(this._LocalizationService);
      const t_message = translator.transform('errorcode5', null);
      this._UiHelper.errorSnackBar(t_message, '');
      return;
    }

    let limitId = '';
    limitId = e.GameUrl;

    if (limitId == '') limitId = '1';

    (this.document.location.href =
      '/casinogame.html?uid=' +
      e.GameId +
      '&t=' +
      e.CasinoType +
      '&l=' +
      limitId +
      '&e=' +
      Date.now().toString() +
      '&langcode=' +
      this._LocalizationService.LANGCODE +
      '&gamename=' +
      e.Name.replace(':', 'xxxx')),
      'Code1x2',
      '_blank';
    //todo i'm not sure if it's works?
  }
}
